import React, { Fragment, useRef, useState } from 'react'
import styled from 'styled-components'
import { Modal, Button, Table } from 'react-bootstrap'
import Colors from '../../constants/Colors'
import Papa from 'papaparse'
import axios from 'axios'
import config from '../../config'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

const UploadCsvModal = (props) => {
  const { roundDate, isOpenModal, setIsOpenModal } = props
  const [dataAllStatus, setDataAllStatus] = useState([])
  const [dataSuccess, setDataSuccess] = useState([])
  const [dataFailed, setDataFailed] = useState([])
  const [verifyError, setVerifyError] = useState(false)
  const [dataVerifyNotFound, setDataVerifyNotFound] = useState([])
  const [dataVerifyInvalidStatus, setDataVerifyInvalidStatus] = useState([])
  const [fileErrorIsWarning, setFileErrorIsWarning] = useState(false)
  const [inputMethod, setInputMethod] = useState('csv')
  const [manualUserNos, setManualUserNos] = useState('')
  const [manualStatus, setManualStatus] = useState('Success')
  const [activeTab, setActiveTab] = useState('success')
  const [activeTabVerify, setActiveTabVerify] = useState('notFound')
  const [isDisabledSave, setIsDisabledSave] = useState(true)
  const imageRef = useRef()
  const dispatch = useDispatch()

  const tabList = [
    {
      name: 'success',
      label: 'ทำรายการสำเร็จ',
    },
    {
      name: 'failed',
      label: 'ทำรายการไม่สำเร็จ ',
    },
  ]

  const tabListVerify = [
    {
      name: 'notFound',
      label: 'ไม่ถูกรางวัล',
    },
    {
      name: 'invalidStatus',
      label: 'อัพเดทสถานะซ้ำ',
    },
  ]

  const rowHeaderCSV = [
    'เลขที่',
    'ชื่อผู้รับเงิน',
    'บัญชี/พร้อมเพย์',
    'รหัส/สาขา',
    'จำนวนเงินทั้งหมด',
    'จำนวนเงินใบแจ้งหนี้',
    'ภาษีมูลค่าเพิ่ม',
    'ภาษีหัก ณ ที่จ่าย',
    'เงินที่จ่ายทั้งหมด',
    'ค่าธรรมเนียม',
    'สถานะ',
    'เหตุผล',
  ]

  const getVisibleColumns = () => {
    const columns = rowHeaderCSV.filter((header) =>
      ['เลขที่', 'ชื่อผู้รับเงิน', 'บัญชี/พร้อมเพย์', 'รหัส/สาขา', 'เงินที่จ่ายทั้งหมด'].includes(header),
    )
    return columns
  }

  const getVisibleColumnsVerify = () => {
    const columns = rowHeaderCSV.filter((header) => ['ชื่อผู้รับเงิน', 'สถานะ'].includes(header))
    return columns
  }

  const onSelectCsv = (element) => {
    const file = element.target.files[0]
    if (!file) return

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const successData = result.data.filter((row) => row['สถานะ'] === 'Success')
        const failedData = result.data.filter((row) => row['สถานะ'] === 'Failed' || row['สถานะ'] === 'Failed (OUR)')

        const objectKeys = Object.keys(result.data[0])
        const statusResult = ['Success', 'Failed', 'Failed (OUR)']
        const hasData = successData.length > 0 || failedData.length > 0

        const isHeadersMatch =
          rowHeaderCSV.length === objectKeys.length &&
          rowHeaderCSV.every((header, index) => header === objectKeys[index])

        const isValidStatus = result.data.every((row) => statusResult.includes(row['สถานะ']))

        if (!hasData || !isValidStatus || !isHeadersMatch) {
          setFileErrorIsWarning(true)
          return
        }

        setDataAllStatus(result.data)
        setDataSuccess(successData)
        setDataFailed(failedData)
        setFileErrorIsWarning(false)
      },
      error: (err) => {
        console.error('CSV parse error:', err)
        setFileErrorIsWarning(true)
      },
    })
  }

  const selectTab = (tab) => {
    setActiveTab(tab)
    document.getElementById('scrollable-table-body').scrollTop = 0
  }

  const selectTabVerify = (tab) => {
    setActiveTabVerify(tab)
    document.getElementById('scrollable-table-body').scrollTop = 0
  }

  const handleManualSubmit = () => {
    const userNos = [...new Set(manualUserNos.split('\n').map((item) => item.trim()).filter((item) => item !== ''))]
    if (userNos.length === 0) return

    const baseRow = rowHeaderCSV.reduce((acc, col) => ({ ...acc, [col]: '-' }), {})

    const resultData = userNos.map((userNo, index) => ({
      ...baseRow,
      'เลขที่': index + 1,
      'ชื่อผู้รับเงิน': userNo,
      'สถานะ': manualStatus,
    }))

    const successData = manualStatus === 'Success' ? resultData : []
    const failedData = manualStatus === 'Failed' ? resultData : []

    setDataAllStatus(resultData)
    setDataSuccess(successData)
    setDataFailed(failedData)
    setActiveTab(manualStatus === 'Success' ? 'success' : 'failed')
  }

  const displayData = activeTab === 'success' ? dataSuccess : dataFailed
  const displayDataVerify = activeTabVerify === 'notFound' ? dataVerifyNotFound : dataVerifyInvalidStatus
  const hasData = dataSuccess.length > 0 || dataFailed.length > 0
  const shouldShowXlSize = hasData

  const updateTransfer = async (roundDate, success, failed) => {
    const successUserNos = success.map((item) => item['ชื่อผู้รับเงิน'])
    const failedUserNos = failed.map((item) => item['ชื่อผู้รับเงิน'])

    try {
      dispatch({ type: 'loading_show' })

      const response = await axios.post(
        `${config.apiAdminGateway}/api/v2/prizes/status`,
        { roundDate, userNosSuccess: successUserNos, userNosInvalidBankAccount: failedUserNos },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )

      if (response.data.status.code === 0) {
        Swal.fire({
          title: 'อัพเดทสถานะสำเร็จ',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: Colors.BLUE,
          confirmButtonText: 'ปิด',
        }).then(() => {
          setIsOpenModal(false)
          window.location.reload()
        })
      } else {
        setVerifyError(true)
        Swal.fire({
          title: 'อัพเดทสถานะไม่สำเร็จ',
          text: response.data.status.description,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: Colors.LIGHT_RED,
          confirmButtonText: 'ปิด',
        }).then(() => {
          verifyTransfer(roundDate, dataAllStatus)
        })
      }

      dispatch({ type: 'loading_hide' })
    } catch (error) {
      Swal.fire({
        title: 'เกิดข้อผิดพลาด',
        text: error.message,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: Colors.LIGHT_RED,
        confirmButtonText: 'ปิด',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const verifyTransfer = async (roundDate, dataAllStatus) => {
    const userNos = dataAllStatus.map((item) => item['ชื่อผู้รับเงิน'])

    try {
      dispatch({ type: 'loading_show' })
      const response = await axios.post(
        `${config.apiAdminGateway}/api/v2/prizes/status/verify`,
        { roundDate, userNos, status: 'NONE' },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )

      const { notFound, invalidStatus } = response.data.data
      const isSuccess = response.data.status.code === 0 && notFound.length === 0 && invalidStatus.length === 0

      if (isSuccess) {
        setIsDisabledSave(false)
        Swal.fire({
          title: 'ตรวจสอบสถานะสำเร็จ',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: Colors.BLUE,
          confirmButtonText: 'ปิด',
        })
      } else {
        setVerifyError(true)
        setIsDisabledSave(true)
        setDataVerifyNotFound(notFound.map((userNo) => ({ ชื่อผู้รับเงิน: userNo, สถานะ: 'ไม่พบข้อมูล' })))
        setDataVerifyInvalidStatus(invalidStatus.map((userNo) => ({ ชื่อผู้รับเงิน: userNo, สถานะ: 'อัพเดทสถานะซ้ำ' })))
        Swal.fire({
          title: 'พบข้อผิดพลาด',
          text: 'กรุณาตรวจสอบข้อมูลในตาราง',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: Colors.LIGHT_RED,
          confirmButtonText: 'ปิด',
        })
      }
    } catch (error) {
      Swal.fire({
        title: 'เกิดข้อผิดพลาด',
        text: error.message,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: Colors.LIGHT_RED,
        confirmButtonText: 'ปิด',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const closeModal = () => {
    setIsOpenModal(false)
    setDataAllStatus([])
    setDataSuccess([])
    setDataFailed([])
    setVerifyError(false)
    setFileErrorIsWarning(false)
    setActiveTab('success')
    setActiveTabVerify('notFound')
    setIsDisabledSave(true)
    setInputMethod('csv')
    setManualUserNos('')
    setManualStatus('Success')
  }

  return (
    <Modal
      size={shouldShowXlSize && 'xl'}
      show={isOpenModal}
      centered
      style={{
        padding: '2rem 0',
        background: 'rgba(0,0,0,0.3)',
      }}
    >
      <Modal.Header>
        {verifyError ? 'ผลการตรวจสอบสถานะ' : 'อัพเดทสถานะ'}
        <Button variant="xl" className="close" onClick={closeModal}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 700, overflow: 'hidden' }}>
        {hasData ? (
          <div className="w-full">
            {verifyError ? (
              <Fragment>
                {tabListVerify.map((tab) => (
                  <TabButton
                    key={tab.name}
                    onClick={() => selectTabVerify(tab.name)}
                    active={activeTabVerify === tab.name}
                  >
                    {tab.label}
                  </TabButton>
                ))}

                <SummaryLengthStatus>จำนวน {displayDataVerify.length} รายการ</SummaryLengthStatus>

                <TableStyled>
                  <thead>
                    <tr>
                      {getVisibleColumnsVerify().map((header) => (
                        <th key={header}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody id="scrollable-table-body">
                    {displayDataVerify.length > 0 ? (
                      displayDataVerify.map((row) => (
                        <tr key={`${row['ชื่อผู้รับเงิน']}`}>
                          {getVisibleColumnsVerify().map((col) => (
                            <td key={col}>{row[col]}</td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="100%" style={{ textAlign: 'center', padding: '1rem' }}>
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    )}
                  </tbody>
                </TableStyled>
              </Fragment>
            ) : (
              <Fragment>
                {tabList.map((tab) => (
                  <TabButton key={tab.name} onClick={() => selectTab(tab.name)} active={activeTab === tab.name}>
                    {tab.label}
                  </TabButton>
                ))}

                <SummaryLengthStatus>จำนวน {displayData.length} รายการ</SummaryLengthStatus>

                <TableStyled>
                  <thead>
                    <tr>
                      {getVisibleColumns().map((header) => (
                        <th key={header}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody id="scrollable-table-body">
                    {displayData.length > 0 ? (
                      displayData.map((row) => (
                        <tr key={`${row['เลขที่']}-${row['ชื่อผู้รับเงิน']}`}>
                          {getVisibleColumns().map((col) => (
                            <td key={col}>{row[col]}</td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="100%" style={{ textAlign: 'center', padding: '1rem' }}>
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    )}
                  </tbody>
                </TableStyled>
              </Fragment>
            )}
          </div>
        ) : (
          <Fragment>
            <div className="d-flex w-100 mb-3 border-bottom">
              <TabButton active={inputMethod === 'csv'} onClick={() => setInputMethod('csv')}>
                อัพโหลดรายชื่อ
              </TabButton>
              <TabButton active={inputMethod === 'manual'} onClick={() => setInputMethod('manual')}>
                กรอกรหัสสมาชิก
              </TabButton>
            </div>

            {inputMethod === 'csv' ? (
              <Fragment>
                <div>แนบไฟล์</div>
                <div htmlFor="upload-image" className="border border p-4">
                  <UploadSlip>
                    <ChooseFileLabel warning={fileErrorIsWarning} htmlFor="upload-image">
                      เลือกไฟล์ CSV
                    </ChooseFileLabel>
                  </UploadSlip>
                </div>
                <input
                  disabled={false}
                  ref={imageRef}
                  type="file"
                  id="upload-image"
                  name="image-file"
                  accept=".csv"
                  onChange={(event) => onSelectCsv(event)}
                  hidden
                />
                {fileErrorIsWarning && (
                  <WarningErrorTitle>ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบและอัพโหลดใหม่อีกครั้ง</WarningErrorTitle>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <div className="mb-3 text-left">
                  <label>สถานะ</label>
                  <div className="d-flex mt-2">
                    {[
                      { value: 'Success', label: 'ทำรายการสำเร็จ' },
                      { value: 'Failed', label: 'ทำรายการไม่สำเร็จ' },
                    ].map((status) => (
                      <label key={status.value} className="mr-4 d-flex align-items-center cursor-pointer" style={{ cursor: 'pointer' }}>
                        <input
                          type="radio"
                          name="manualStatus"
                          value={status.value}
                          checked={manualStatus === status.value}
                          onChange={(e) => setManualStatus(e.target.value)}
                          className="mr-2"
                        />
                        {status.label}
                      </label>
                    ))}
                  </div>
                </div>
                <div className="mb-3 text-left">
                  <label>รหัสสมาชิก (1 รายชื่อ ต่อ 1 บรรทัด)</label>
                  <textarea
                    className="form-control"
                    rows={10}
                    value={manualUserNos}
                    onChange={(e) => setManualUserNos(e.target.value)}
                    placeholder="กรอกรหัสสมาชิกที่นี่..."
                    style={{ width: '100%', resize: 'vertical' }}
                  />
                </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        {hasData && !verifyError ? (
          <Fragment>
            <Button size="sm" onClick={() => verifyTransfer(roundDate, dataAllStatus)}>
              ตรวจสอบสถานะ
            </Button>
            <Button
              disabled={isDisabledSave}
              size="sm"
              onClick={() => updateTransfer(roundDate, dataSuccess, dataFailed)}
            >
              บันทึก
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            {inputMethod === 'manual' && manualUserNos.trim() !== '' && (
              <Button size="sm" onClick={handleManualSubmit}>
                ตกลง
              </Button>
            )}
            <Button size="sm" onClick={closeModal}>
              ปิด
            </Button>
          </Fragment>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default UploadCsvModal

const UploadSlip = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 4px;
`

const ChooseFileLabel = styled.label`
  background-color: #0b2a97;
  color: ${Colors.WHITE};
  padding: 0.5rem;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  width: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  white-space: nowrap;
`
const TabButton = styled.button`
  border: none;
  width: 50%;
  background-color: transparent;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  border-bottom: ${(props) => (props.active ? `2px solid ${Colors.BLUE}` : 'none')};
`

const SummaryLengthStatus = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  height: 40px;
  background-color: ${Colors.WHITE};
  width: 100%;
  text-align: start;
  color: ${Colors.BLACK};
`

const WarningErrorTitle = styled.div`
  margin: 0;
  padding-top: 4px;
  font-size: 12px;
  text-align: left;
  color: ${Colors.DARK_RED};
`

const TableStyled = styled(Table)`
  .table {
    border: 1px solid ${Colors.LIGHT_GREY};
    border-radius: 6px;
    text-align: center;
  }
  thead {
    background-color: ${Colors.LIGHT_GREY};
  }
  tbody {
    overflow-y: scroll;
    background-color: ${Colors.WHITE};
    width: 100%;
    display: block;
    max-height: 500px;
  }
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    padding-bottom: 50px;
  }
  th,
  td {
    padding: 0.75rem;
    text-align: center;
    border-bottom: 1px solid ${Colors.GREY};
  }
`
